import { Helmet } from 'react-helmet-async';
import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { StatisticsContent } from '@/pageContents/statistics/StatisticsContent';
import { Permission } from '@/models/user';

const Page: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Dashboard | Starjack Backoffice</title>
            </Helmet>

            <StatisticsContent />
        </>
    );
};

Page.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Page.isProtected = true;
Page.permissions = [Permission.STATISTIC_NAV];

export default Page;
